module.exports = __webpack_public_path__ + "img/74.5da1dd6e.jpg";